import { useMemo } from 'react';
import { useRecoilValue } from 'recoil';

import { FlowTileTotalsState } from 'views/complex-onboarding-flow/stores/states';

/**
 * __simplici_flow_total__
 * Single source of truth for "what does this flow bill", shared by the
 * footer's FlowTotal box and the canvas stat strip — both read the same
 * FlowTileTotalsState the tiles themselves write, so neither can quote a
 * number the tiles on screen don't back up.
 */
export const useFlowTotals = () => {
	const tileTotals = useRecoilValue(FlowTileTotalsState);

	return useMemo(() => {
		const entries = Object.values(tileTotals ?? {});
		const { low, high, steps } = entries.reduce(
			(acc, tile) => {
				const min = Number(tile?.min ?? 0);
				if (!Number.isFinite(min) || min <= 0) return acc;
				const max = Number(tile?.max ?? 0);
				return {
					low: acc.low + min,
					high: acc.high + (Number.isFinite(max) && max > min ? max : min),
					steps: acc.steps + 1,
				};
			},
			{ low: 0, high: 0, steps: 0 }
		);
		return { low, high, steps, isRange: high > low };
	}, [tileTotals]);
};
